export default {
    ENV: 'PROD',
    BASE_URL: 'https://adminapi-wsbobetty.meridianbet.com/api',
    APP_MANAGEMENT_API: 'http://10.10.20.70:8080/api',
    APP_DOWNLOAD_URL: 'https://bettyupdatebucket.s3.eu-central-1.amazonaws.com'
  }
  
  